<template>
    <div v-if="loading" class="center__page">
      <i class="el-icon-loading" style="font-size: 40px;"></i>
    </div>
    <div v-else-if="error" class="center__page" style="flex-direction: column;">
      <h2>Document Not Available</h2>
      <p>The document you are trying to access may be missing or temporarily unavailable.</p>
      <base-button @click="retry">Try Again</base-button>
    </div>
    <div v-else v-html="htmlContent"></div>
  </template>
  
  <script>
  export default {
    props: {
      path: {
        type: String,
        required: true,
      },
      templateVars: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        htmlContent: '',
        rawHtmlTemplate: '',
        loading: true,
        error: false,
        localTemplateVars: { ...this.templateVars },
      };
    },
    mounted() {
      this.loadAndReplaceTemplate(this.path);
    },
    methods: {
      async loadAndReplaceTemplate(path) {
        this.htmlContent = '';
        this.rawHtmlTemplate = '';
        this.error = false;
        this.loading = true;
        try {
          const htmlRaw = await this.$store.dispatch('getDocumentAgreementFile', {
            name: path,
          });

          let cleanedHtml = htmlRaw.data
            .replace(/–/g, '-')
            .replace(/\uFFFD/g, '')
            .replace(/(:\s*)yellow/gi, '')
            .replace(/<table[\s\S]*?<\/table>/gi, '')
            .replace(/EXHIBIT A/gi, '')
            .replace(/<del[^>]*>[\s\S]*?<\/del>/gi, '')
            .replace(/<ins[^>]*>/gi, '<span>')
            .replace(/<\/ins>/gi, '</span>')
            .replace(/<span class="msoIns">/gi, '<span>')
            .replace(/<\/span>/gi, '</span>');

          this.rawHtmlTemplate = cleanedHtml;
          this.replaceTemplateVars();
        } catch (err) {
          console.error('Failed load template:', err);
          this.error = true;
        } finally {
          this.loading = false;
        }
      },
      replaceTemplateVars() {
        if (!this.rawHtmlTemplate) return;

        const html = this.rawHtmlTemplate.replace(/\{([\s\S]*?)\}/g, (match, key) => {
          const cleanedKey = key
            .replace(/<[^>]+>/g, '')
            .replace(/\s+/g, ' ')
            .trim();
          return this.localTemplateVars[cleanedKey] || match;
        });

        this.htmlContent = html;
      },
      retry() {
        this.loadAndReplaceTemplate(this.path);
      },
    },
    watch: {
      templateVars: {
        handler(newValue){
            this.localTemplateVars = { ...newValue };
            this.replaceTemplateVars();
        },
        deep: true,
        immediate: true,
      }
    }
  };
  </script>
  
<style>
.center__page {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
}

span.msoIns {
  color: black !important;
  text-decoration: none !important;
}
</style>
  